// extracted by mini-css-extract-plugin
module.exports = {"subscribe":"Subscribe-module--subscribe--izC0y"};